module.exports = __webpack_public_path__ + "static/media/card-content-image.4c755988.svg";